import { render, staticRenderFns } from "./Trailers.vue?vue&type=template&id=3422178b&scoped=true&"
import script from "./Trailers.vue?vue&type=script&lang=js&"
export * from "./Trailers.vue?vue&type=script&lang=js&"
import style0 from "./Trailers.vue?vue&type=style&index=0&id=3422178b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3422178b",
  null
  
)

export default component.exports